import { type LinkProps, Link as RouterLink } from "react-router-dom";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ token, css }) => ({
  link: css`
    display: inline-block;
    padding: ${token.paddingSM}px 0;
    margin: -${token.paddingSM}px 0;
    color: inherit;

    &:hover {
      color: inherit;
    }
  `,
}));

/**
 * A router link that fills the vertical padding of its parent tab, so the whole tab is clickable.
 *
 * Forwards every react-router `Link` prop.
 */
export function Link({ className, ...props }: LinkProps) {
  const { styles, cx } = useStyles();

  return <RouterLink {...props} className={cx(styles.link, className)} />;
}
